// @flow
import React, { type Node, Fragment } from 'react';

import PlainIcon, { iconTypes, colorTypes } from 'app/common/ui-next/plain-icon';


type Props = {
  portion: ?string,
}

const Portion = ({ portion }: Props): Node => {
  if (!portion) return ('—');

  return (
    <Fragment>
      <PlainIcon
        type={iconTypes.PORTION}
        colorType={colorTypes.COLOR_DARKGRAY}
      />
      &nbsp;
      {portion}
    </Fragment>
  );
};

export default Portion;
